export default "<div class=\"proxy-response-download\">\r\n</div>";